package org.example.site_web.to3d

import org.w3c.dom.DOMPoint
import org.w3c.dom.DOMMatrix
import org.w3c.dom.DOMPointInit

class A3DVertex(val x: Double, val y: Double, val z:Double)
{ val domPoint: DOMPoint = DOMPoint(x,y,z,1.0)

    constructor(pt : DOMPoint) : this(pt.x,pt.y,pt.z)
};

class A2DVertex(val x: Double, val y: Double){
    fun doTrans2D(tx:Double=0.0, ty:Double = 0.0): A2DVertex{
        return A2DVertex(this.x + tx,this.y + ty)
    }
}

class A3DTransform(val rotY: Double,
                   val focal: Double = 800.0,
                    val distance: Double = 1400.0,)
{
    //DOMMatrix
    var matrix: DOMMatrix =  DOMMatrix(arrayOf(1.0, 0.0, 0.0,
                                                0.0, 0.0, 1.0,
                                                0.0, 0.0, 0.0,
                                                0.0, 1.0, 0.0,
                                                0.0, 0.0, 0.0, 1.0));
    init{
        matrix = matrix.rotateAxisAngleSelf(0.0,0.5,0.0,rotY)
        matrix = matrix.scale(2.0,2.0,2.0)
    }

    fun doRotTo2D(aPoint: A3DVertex): A2DVertex{
        val a = matrix.transformPoint(DOMPointInit(aPoint.domPoint.x,aPoint.domPoint.y,aPoint.domPoint.z))
        //3D points
        return A2DVertex(a.x*(focal/(a.z-distance)),a.y*(focal/(distance-a.z)))
    }



};